(() => {
  'use strict';

  const ROOT = '[data-gift-package-selector]';
  const GIFT_VARIANT_ID = 55308416418133;

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const form = document.getElementById('cart');
    if (!form) return;

    root.dataset.initialized = 'true';

    const status = root.querySelector('[data-gift-package-status]');
    const addButton = root.querySelector('[data-add-gift-package]');
    const saveButton = root.querySelector('[data-gift-save]');
    const error = root.querySelector('[data-gift-error]');
    const checkoutButton = document.getElementById('checkout');

    const cartUrl = (path) =>
      `${window.Shopify.routes.root}${path}`;

    let busy = false;
    let allowNativeSubmit = false;

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    function showError(message) {
      if (error) {
        error.hidden = false;
        error.textContent = message;
      }

      setStatus(message);
    }

    function getGroups() {
      return [...root.querySelectorAll('[data-package-group]')];
    }

    function getCheckboxes() {
      return [...root.querySelectorAll(
        '[data-package-group] input[type="checkbox"]'
      )];
    }

    function getBraceletIds() {
      return [...new Set(
        getCheckboxes().map((checkbox) => checkbox.value)
      )];
    }

    function validate() {
      const groups = getGroups();
      const checkboxes = getCheckboxes();
      const braceletIds = getBraceletIds();

      let valid =
        groups.length > 0 &&
        braceletIds.length > 0 &&
        checkboxes.length > 0;

          if (groups.length > braceletIds.length) {
        if (error) {
          error.hidden = false;
          error.textContent =
            `Hai ${braceletIds.length} braccialetti ma ${groups.length} confezioni totali (una è già inclusa). Riduci le confezioni extra prima di procedere.`;
        }

        root.dataset.valid = 'false';
        return false;
      }
      // Ogni esemplare deve essere assegnato esattamente una volta.
      braceletIds.forEach((id) => {
        const selectedCount = checkboxes.filter(
          (checkbox) =>
            checkbox.value === id && checkbox.checked
        ).length;

        if (selectedCount !== 1) valid = false;
      });

      // Ogni confezione deve contenere almeno un braccialetto.
      groups.forEach((group) => {
        const selected = group.querySelectorAll(
          'input[type="checkbox"]:checked'
        );

        const groupError = group.querySelector(
          '[data-package-error]'
        );

        if (groupError) {
          groupError.hidden = selected.length > 0;
        }

        if (selected.length === 0) valid = false;
      });

      if (error) {
        error.hidden = valid;
        error.textContent = valid
          ? ''
          : 'Assegna ogni braccialetto a una sola confezione e utilizza tutte le confezioni.';
      }

      root.dataset.valid = valid ? 'true' : 'false';

      return valid;
    }

    async function refreshCart() {
      const response = await fetch(cartUrl('cart.js'), {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error(
          'Impossibile verificare il carrello. Riprova.'
        );
      }

      return response.json();
    }

     function checkCartConsistency(cart) {
      const extraPackages = cart.items
        .filter(
          (item) => Number(item.variant_id) === GIFT_VARIANT_ID
        )
        .reduce((sum, item) => sum + Number(item.quantity), 0);

      const expectedPackages = extraPackages + 1;
      const groups = getGroups();

      // Ricava le righe dei braccialetti dagli identificativi
      // generati dal Liquid per il selettore.
      const braceletLineKeys = new Set(
        getBraceletIds().map((id) => {
          const marker = id.lastIndexOf('-unit-');
          return marker > 0 ? id.slice(0, marker) : null;
        }).filter(Boolean)
      );

      // Conta le quantità reali delle righe identificate come
      // braccialetti dal selettore Liquid.
      const braceletCount = cart.items
        .filter((item) => braceletLineKeys.has(item.key))
        .reduce((sum, item) => sum + Number(item.quantity), 0);

      if (expectedPackages > braceletCount) {
        throw new Error(
          `Hai ${braceletCount} braccialetti ma ${expectedPackages} confezioni totali (una inclusa). Riduci le confezioni extra prima di procedere.`
        );
      }

      if (groups.length !== expectedPackages) {
        throw new Error(
          'Il numero di confezioni non è aggiornato. Ricarica il carrello e ripeti la personalizzazione.'
        );
      }

      const checkboxes = getCheckboxes();
      const braceletIds = getBraceletIds();

      if (!checkboxes.length || !braceletIds.length) {
        throw new Error(
          'Non ci sono braccialetti da assegnare.'
        );
      }

      const cartLines = new Map(
        cart.items.map((item) => [item.key, item])
      );

      const representedUnits = new Map();

      braceletIds.forEach((id) => {
        const marker = id.lastIndexOf('-unit-');

        if (marker < 1) {
          throw new Error(
            'Identificativo del braccialetto non valido. Ricarica il carrello.'
          );
        }

        const lineKey = id.slice(0, marker);
        const unitNumber = Number(id.slice(marker + 6));
        const line = cartLines.get(lineKey);

        if (
          !line ||
          !Number.isInteger(unitNumber) ||
          unitNumber < 1 ||
          unitNumber > Number(line.quantity)
        ) {
          throw new Error(
            'I braccialetti sono cambiati nel carrello. Ricarica la pagina e ripeti le assegnazioni.'
          );
        }

        if (!representedUnits.has(lineKey)) {
          representedUnits.set(lineKey, new Set());
        }

        representedUnits.get(lineKey).add(unitNumber);
      });

      representedUnits.forEach((units, lineKey) => {
        const line = cartLines.get(lineKey);

        if (!line) {
          throw new Error(
            'Una riga del carrello non è più disponibile. Ricarica il carrello.'
          );
        }

        for (let unit = 1; unit <= Number(line.quantity); unit++) {
          if (!units.has(unit)) {
            throw new Error(
              'La quantità dei braccialetti è cambiata. Ricarica il carrello e ripeti le assegnazioni.'
            );
          }
        }
      });

      return true;
    }

    function getAssignments() {
      return getGroups().map((group, index) => ({
        package: index + 1,
        bracelets: [
          ...group.querySelectorAll(
            'input[type="checkbox"]:checked'
          )
        ].map((checkbox) => checkbox.value)
      }));
    }

    // Se una scelta cambia, il salvataggio precedente non è più valido.
    root.addEventListener('change', (event) => {
      if (
        !event.target.matches(
          '[data-package-group] input[type="checkbox"]'
        )
      ) {
        return;
      }

      const checkbox = event.target;

      if (checkbox.checked) {
        getCheckboxes().forEach((other) => {
          if (
            other !== checkbox &&
            other.value === checkbox.value
          ) {
            other.checked = false;
          }
        });
      }

      root.dataset.saved = 'false';
      validate();
    });

    async function addPackage() {
      if (busy) return;

      busy = true;
      root.dataset.saved = 'false';

      if (addButton) addButton.disabled = true;

      setStatus('Aggiunta della confezione in corso…');

      try {
        const response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: GIFT_VARIANT_ID,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          const details = await response.json().catch(() => null);

          throw new Error(
            details?.description ||
            'Non è stato possibile aggiungere la confezione.'
          );
        }

        window.location.reload();
      } catch (err) {
        setStatus(
          err.message || 'Errore durante l’aggiunta della confezione.'
        );
      } finally {
        busy = false;

        if (addButton) addButton.disabled = false;
      }
    }

    async function saveAssignments() {
      if (busy) return;

      if (!validate()) {
        root.dataset.saved = 'false';

        showError(
          'Completa tutte le assegnazioni prima di salvare.'
        );

        return;
      }

      busy = true;
      root.dataset.saved = 'false';

      if (saveButton) saveButton.disabled = true;

      setStatus('Verifica del carrello e salvataggio…');

      try {
        const cart = await refreshCart();

        checkCartConsistency(cart);

        if (!validate()) {
          throw new Error(
            'Le assegnazioni non sono complete.'
          );
        }

        const assignments = getAssignments();
        const serialized = JSON.stringify(assignments);

        const response = await fetch(cartUrl('cart/update.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Confezioni regalo': serialized
            }
          })
        });

        if (!response.ok) {
          throw new Error(
            'Salvataggio non riuscito. Riprova.'
          );
        }

        const savedCart = await refreshCart();

        checkCartConsistency(savedCart);

        if (
          savedCart.attributes?.['Confezioni regalo'] !== serialized
        ) {
          throw new Error(
            'Non è stato possibile confermare il salvataggio. Riprova.'
          );
        }

        root.dataset.saved = 'true';

        if (error) error.hidden = true;

        setStatus('Personalizzazione salvata correttamente.');
      } catch (err) {
        root.dataset.saved = 'false';

        showError(
          err.message || 'Errore durante il salvataggio.'
        );
      } finally {
        busy = false;

        if (saveButton) saveButton.disabled = false;
      }
    }

    if (addButton) {
      addButton.addEventListener('click', addPackage);
    }

    if (saveButton) {
      saveButton.addEventListener('click', saveAssignments);
    }

    // Intercetta il clic sul pulsante checkout anche se si trova
    // in una sezione diversa del tema.
    document.addEventListener('click', (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const control = target.closest(
        '#checkout, button[name="checkout"], input[name="checkout"]'
      );

      if (!control) return;

      if (
        root.dataset.saved !== 'true' ||
        !validate()
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        root.dataset.saved = 'false';

        showError(
          'Prima di procedere, assegna tutti i braccialetti alle confezioni e salva la personalizzazione.'
        );

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, true);

    // Controllo aggiuntivo quando il form viene inviato direttamente.
    form.addEventListener('submit', async (event) => {
      // Consente l'invio nativo soltanto dopo il controllo finale.
      if (allowNativeSubmit) {
        allowNativeSubmit = false;
        return;
      }

      event.preventDefault();

      if (busy) return;

      if (
        root.dataset.saved !== 'true' ||
        !validate()
      ) {
        root.dataset.saved = 'false';

        showError(
          'Completa e salva la personalizzazione prima di proseguire.'
        );

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }

      busy = true;
      setStatus('Controllo finale del carrello…');

      try {
        const cart = await refreshCart();

        checkCartConsistency(cart);

        if (
          root.dataset.saved !== 'true' ||
          !validate()
        ) {
          throw new Error(
            'La personalizzazione non è più valida. Salvala nuovamente.'
          );
        }

        // Mantiene il pulsante di checkout come pulsante di invio,
        // evitando di perdere il parametro name="checkout".
        allowNativeSubmit = true;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(
            event.submitter || checkoutButton || undefined
          );
        } else {
          allowNativeSubmit = false;

          throw new Error(
            'Il browser non supporta l’invio sicuro del modulo. Ricarica la pagina e riprova.'
          );
        }
      } catch (err) {
        allowNativeSubmit = false;
        root.dataset.saved = 'false';

        showError(
          err.message || 'Controllo non riuscito. Riprova.'
        );

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      } finally {
        busy = false;
      }
    });

    validate();
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();